import { pr } from '@/utils/pxToRem';
import { Grid, Stack, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { style } from '@/styles/globals';
import ImgContainer from '../ImgContainer';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';

export const TypographyLabel = styled(Typography)`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${style.neutral.black};
`;

export const TypographyContent = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${style.neutral.gray};
`;

const data = [
  {
    img: 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/WhyBookUsCtC/book-us-ho-tro.webp',
    label: 'Chắc chắn có vé',
    content: 'Tích hợp trực tiếp với tất cả các hãng hàng không lớn: Vietnam Airlines, Vietjet Air, Bamboo Airway, Vietravel Airlines, Pacific Airlines..',
  },
  {
    img: 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/WhyBookUsCtC/book-us_thanh_toan.webp',
    label: 'Đa dạng hình thức thanh toán',
    content: 'Thanh toán đa dạng và an toàn với ví điện tử (Momo, Zalopay...), thẻ ATM nội địa, thẻ Visa/Master.',
  },
  {
    img: 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/WhyBookUsCtC/book-us_uu_dai.webp',
    label: 'Luôn đặt được các vé ưu đãi',
    content: 'Vexere đang có chương trình ưu đãi giảm giá 20K cho tất cả các chuyến bay rẻ nhất trong ngày.',
  },
  {
    img: 'https://storage.googleapis.com/goyolo-uat/images/SeoVexImprove/WhyBookUsCtC/book-us-ho-tro.webp',
    label: 'Hỗ trợ nhanh chóng và chu đáo',
    content: 'Vexere luôn thấu hiểu khách hàng và hỗ trợ bạn mọi lúc mọi nơi cho hành trình trọn vẹn.',
  },
];

const SectionWhyBookUs = ({ lang }: { lang?: ILangObj }) => (
  <Stack
    spacing={pr`16px`}
    marginTop={pr`16px`}
    direction="row"
  >
    {lang?.UniqueSellingPoints?.children?.map((x, index) => (
      <Grid
        key={index}
        container
        width="100%"
        sx={{
          justifyContent: 'space-around',
        }}
      >
        <Grid
          // item
          xs={2}
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            className="lazyload"
            style={{
              width: '57px',
              height: '57px',
            }}
          >
            <ImgContainer
              src={x.img}
              alt="logo"
              width="57px"
              height="57px"
            />
          </div>
        </Grid>
        <Grid
          // item
          xs={1}
        />
        <Grid
          // item
          xs={9}
          sx={{
            position: 'relative',
            maxWidth: pr`163px`,
          }}
        >
          <TypographyLabel>
            {x.label}
          </TypographyLabel>
          <TypographyContent>
            {x.content}
          </TypographyContent>
        </Grid>
      </Grid>
    ))}
  </Stack>
);

export default SectionWhyBookUs;
